import { DataColumns } from '../DataColumns/DataColumns';
import { MultiViewCalenderFilterCell } from 'smart-react';
import { GridDateCell } from '../../../Core/Components/Filter/FilterElements';
/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  projectId = '',
  versionId = '',
  rolloutDelete,
  rolloutVersion,
  majorVersion,
  downloadRolloutArchive,
  showBugs,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    projectId,
    versionId,
    rolloutDelete,
    rolloutVersion,
    majorVersion,
    downloadRolloutArchive,
    showBugs,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    MultiViewCalenderFilterCell,
  });
};

export default GridColumnsList;
